<template>
    <div class="columns is-multiline">
        <div class="column is-3" v-for="item in feed" :key="item.id" :class="itemClass(item)" @click="toggle(item)">
            <img :src="item.image" />
        </div>
    </div>
</template>
<script>
    import FeedMixin from './FeedMixin';
    export default {
        name: 'InstagramFeed',
        mixins: [FeedMixin]
    }
</script>